module.exports = "<aside id=landing-bg v-bind:style=\"{ backgroundImage: 'url(' + background + ')' }\" _v-0a462969=\"\"></aside>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0a462969!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/Background.vue
 ** module id = 16
 ** module chunks = 0
 **/